import React from "react";
import { ArrowRight } from "lucide-react";
import HeroMotion from "./HeroMotion";

const Banner = (props) => {
  const { dataSource } = props;
  const secondaryIsFile =
    dataSource.button2Href &&
    (dataSource.button2Href.endsWith(".pdf") ||
      /^https?:\/\//.test(dataSource.button2Href));

  return (
    <section className="nfw-hero">
      {dataSource.introImg && (
        <div className="nfw-hero-media" aria-hidden="true">
          <img src={dataSource.introImg} alt="" />
        </div>
      )}
      {dataSource.introImg ? <div className="nfw-hero-shade" /> : null}
      <HeroMotion />
      <div className="nfw-wrap">
        <div className="nfw-hero-copy">
          <h1>
            {dataSource.title}
            <br />
            <em>{dataSource.titleAccent}</em>
          </h1>
          {dataSource.desc ? <p>{dataSource.desc}</p> : null}
          <div className="nfw-hero-actions">
            {dataSource.button && (
              <a className="nfw-btn nfw-btn-solid" href={dataSource.buttonHref}>
                {dataSource.button}
                <ArrowRight size={18} />
              </a>
            )}
            {dataSource.button2 && (
              <a
                className="nfw-btn nfw-btn-ghost nfw-glass"
                href={dataSource.button2Href}
                target={secondaryIsFile ? "_blank" : undefined}
                rel={secondaryIsFile ? "noopener noreferrer" : undefined}
              >
                {dataSource.button2}
              </a>
            )}
          </div>
          {dataSource.links && dataSource.links.length > 0 && (
            <nav className="nfw-hero-links" aria-label={dataSource.linksLabel}>
              {dataSource.links.map((item) => (
                <a href={item.href} key={item.href}>
                  {item.name}
                </a>
              ))}
            </nav>
          )}
        </div>
      </div>
    </section>
  );
};

export default Banner;
